<div class="new-content" *ngIf="!pane || !pane.loaded || !pane.user || !show else contentBlock">
  <loading-line height="40px" width="100%" *ngIf="pane.loading"></loading-line>
</div>
<ng-template #contentBlock>
  <div [class.tablet]="deviceService.isTablet()"
       [class.mobile]="deviceService.isMobile()">
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
      <ng-container side>
        <div class="side-content">
          <span class="subtitle">{{ 'library.user-card.highest-mark' | customLocale }}</span>
          <span *ngIf="false" class="action">{{ 'library.user-card.title-action' | customLocale }}</span>
        </div>
      </ng-container>
    </app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <app-teacher-card [teacher]="user">
      <div class="teaching"
           [class.media]="isMediaPrepared">
        <div class="title-part">
          <app-horizontal-scroll-menu
            [scrollList]="teachingSubjectsList"
            [value]="teachingSubjectIndex"
            (selectItem)="onTeachingSubjectChange($event)">
          </app-horizontal-scroll-menu>
        </div>

        <div class="section-body">
          <p *ngIf="teachingSubject" class="description" [class.media]="isMediaPrepared">
        <span [innerHTML]="descriptionTeachingSubject | striptags | nl2br"
              class="description"></span>
            <span *ngIf="!teachingSubjectMore && descriptionTeachSubLen > 400"
                  class="description more"
                  (click)="teachingSubjectMore = true"> {{ 'user-profile.show-more' | customLocale }}</span>
            <span *ngIf="teachingSubjectMore && descriptionTeachSubLen > 400"
                  class="description more"
                  (click)="teachingSubjectMore = false"> {{ 'user-profile.roll-up' | customLocale }}</span>
          </p>
          <iframe *ngIf="isMediaPrepared"
                  [src]="safeMediaUrl"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  title="video"
                  class="video">
          </iframe>
        </div>
      </div>
    </app-teacher-card>
  </div>
</ng-template>
